export { Breadcrumb } from './breadcrumb'
export { PageBreadcrumbContainer } from './page-breadcrumb-container'
export type {
  BreadcrumbItemNavigation,
  BreadcrumbItemExtended,
  BreadcrumbItemProps,
  DotsSegmentProps,
} from '@/modules/shared/types/breadcrumb'
export { BreadcrumbSkeleton } from './breadcrumb-skeleton'
